import React, { Component } from 'react';

import classNames from 'classnames'

class CarouselNavItem extends Component {
  constructor() {
    super();
    this.state = {
      player: null
    }
  }

  handleClick(){
    this.props.handleClick(this.props.index)
  }

  render() {
    let classes = classNames({
      'navItem': true,
      'active': this.props.current === this.props.index
    })
    return (
      <span className={classes} onClick={this.handleClick.bind(this)}></span>
    );
  }
}

export default CarouselNavItem;


// WEBPACK FOOTER //
// ./src/Components/CarouselNavItem.js